<template>
    <div>
       <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                        <div class="h-thirdColumn w-newColumn">
                            <el-form-item label="大区" prop="areaCode">
                                <brselect :dictNameAsValues=true category="show_area" v-model="q.bigArea" :v="q.bigArea" :clearable="true" ></brselect>
                            </el-form-item>
                            <el-form-item label="省">
                                <el-select v-model.trim="q.province"
                                           placeholder="省" style="width: 68%;" :clearable="true">
                                    <el-option
                                        v-for="item in shenglist"
                                        :key="item.name"
                                        :label="item.name"
                                        :value="item.name">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="负责人">
                                <el-input clearable v-model="q.userCodeNameLike"></el-input>
                            </el-form-item>

                        </div>
                        <div class="h-formBtnOut h-columnCenter">
                            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
                                       @click="createdict">新建负责人</el-button>
                        </div>
                    </el-form>
                </div>
            </div>
            <div class="h-table h-mrt30">
                <el-table
                        @selection-change="handleSelectionChange"
                        ref="ddtable"
                        :data="tableData"
                        stripe
                        border
                        style="width: 100%"
                >
                    <el-table-column
                            type="selection"
                            width="40"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="bigArea"
                        label="大区"
                        width="100"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="province"
                        label="省"
                        width="100"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="city"
                        label="市"
                        width="100"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="userCode"
                        label="负责人工号"
                        width="120"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="userName"
                            label="负责人名称"
                            width="120"
                    >
                    </el-table-column>

                    <el-table-column
                        prop="phone"
                        label="联系电话"
                        width="100"
                    >
                    </el-table-column>

                    <el-table-column
                        prop="email"
                        label="邮箱"
                        width="200"
                    >
                    </el-table-column>

                    <el-table-column
                        prop="cuname"
                        label="创建人"
                        width="120"
                    >
                    </el-table-column>

                    <el-table-column
                            prop="cdate"
                            label="创建时间"
                            width="120"
                    >
                    </el-table-column>

                    <el-table-column
                            prop="lucode"
                            label="修改人"
                            width="120"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="ldate"
                            label="修改时间"
                            width="120"
                    >
                    </el-table-column>

                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="160"
                    >
                        <template slot-scope="scope">
                            <el-button
                                    class="h-tableLink h-btn"
                                    @click="handleEdit(scope.row)">修改</el-button>
                            <el-button
                                    class="h-tableLink h-btn"
                                    @click="handleDelete(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>

                </el-table>
                <div class="h-tableBL" style="margin:20px 0 0 20px;display:flex;justify-content:space-between">
                    <div>
                        <el-button
                                class="h-btn h-formBtn h-bgblueQ"
                                icon="h-el-icon h-el-icon-import"
                                style="margin-left:-20px;"
                                @click="exportExcel" >
                            批量导出
                        </el-button>

                    </div>
                    <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                        <pagination :page="q" @query="query"/>
                    </div>
                </div>
            </div>

            <div>
                <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="h-dialog2">
                    <div class="h-dialogImg">
                        <div class="h-disTable">
                            <div class="h-tableCell">
                                <h1>修改（新建）负责人</h1>
                            </div>
                        </div>
                    </div>
                    <div class="h-formLine">
                        <el-form ref="form" :model="f"
                                 :inline="true"  class="demo-ruleForm h-formbLine h-dialogForm">

                            <el-form-item label="大区" prop="bigArea" :rules="[
                              { required: true, message: '请选择大区', trigger: 'blur'}]" class="h-elformWrap-2">
                                <brselect :dictNameAsValues=true category="show_area" v-model="f.bigArea" :v="f.bigArea" :clearable="true" ></brselect>
                            </el-form-item>

                            <el-form-item label="省" prop="province" :rules="[
                              { required: true, message: '请选择省', trigger: 'blur'}]" class="h-elformWrap-2">
                                <el-select v-model.trim="f.province"  @change="changeArea"
                                           value-key="name"
                                           placeholder="省" :clearable="true">
                                    <el-option
                                        v-for="item in shenglist"
                                        :key="item.code"
                                        :label="item.name"
                                        :value="item.name">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="市" prop="city" class="h-elformWrap-2">
                                <el-select
                                    multiple
                                    :clearable="true"
                                    v-model="f.cityArray" >
                                    <el-option v-for="item in salesCityList"
                                               :key="item.code"
                                               :value="item.name"
                                               :label="item.name"
                                    ></el-option>
                                </el-select>
                            </el-form-item>


                            <el-form-item label="负责人工号" prop="userCode" :rules="[
                                          { required: true, message: '请输负责人工号', trigger: 'blur'},
                                        ]" class="h-elformWrap-2">
                                <el-input v-model.trim="f.userCode"  @change="checkUser"></el-input>
                            </el-form-item>

                            <el-form-item label="负责人名称" prop="userName" :rules="[
                                          { required: true, message: '请输负责人名称', trigger: 'blur'},
                                        ]" class="h-elformWrap-2">
                                <el-input v-model.trim="f.userName"></el-input>
                            </el-form-item>

                            <el-form-item label="手机号码" prop="phone" :rules="[
                                          { required: true, message: '请输入手机号码', trigger: 'blur'},
                                          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
                                        ]" class="h-elformWrap-2">
                                <el-input v-model.trim="f.phone"></el-input>
                            </el-form-item>


                            <el-form-item label="备注" prop="remark"  class="h-elformWrap-2">
                                <el-input v-model.trim="f.remark"></el-input>
                            </el-form-item>


                        </el-form>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="closeM">取 消</el-button>
                        <el-button class="h-btn h-formBtn h-bgblue2" @click="saveOrUpdate">提交保存</el-button>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>
<script>

    import ss from "@/api/SystemService";
    import updownfile from '../../../utils/updownfile'
    export default {
        components: {

        },
        data() {

            return {
                uploaddownexcelflag: false,

                showYonghuflag: false,
                //table列表
                tableData: [],
                shenglist: [],
                salesCityList: [],
                //查询属性
                q: {
                    bigArea:null,
                    province:null,
                    city:null,
                    channelCode:null,
                    userCodeNameLike:null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                //表单
                f:{
                    id:null,
                    bigArea:null,
                    province:null,
                    city:null,
                    cityArray:[],
                    userCode:null,
                    userName:null,
                    phone:null,
                    remark:null,


                },
                optflag:'save',
                //弹出框
                dialogFormVisible: false,
                //表格
                multipleSelection: [],
            }
        },
        created() {
            this.query();
            this.loadArea();
        },
        methods: {

            //检查用户是否存在
            checkUser(code){
                ss.UserService.selectById(code).then(rd => {
                    if(rd.obj==null){
                        this.$msg.msge("该人员在系统中不存在！");
                        this.f.userCode ='';
                        this.f.userCode ='';
                    }else{
                        this.f.userName = rd.obj.username;
                    }
                })
            },

            loadArea() {
                let proSelect = {
                    pcode: 0,
                    level: 1,
                }
                ss.Dictservice.arealist(proSelect).then(rd => {
                    console.log("rdrd",rd)
                    this.shenglist = rd;
                })
            },

            changeArea(provinceName) {
                this.f.city = '';
                this.f.cityArray = [];

                console.log("query",provinceName);
                //查询省代码
                const province = this.shenglist.find(item => item.name === provinceName);
                if (!province) {
                    console.error("未找到省份:", provinceName);
                    return Promise.resolve([]); // 返回一个空 Promise，防止报错
                }
                var areas = [];
                areas.push(province.code)

                return ss.UserService.getCityByArea(areas).then(rd => {
                    this.salesCityList = rd.msg;
                    return rd.msg; // 把数据传下去，方便调用者使用
                })
            },


            query() {
                ss.clueOwner.designSelectPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                })
            },

            handleFilter() {
                this.query();

            },
            createdict(){

                this.f={};
                this.dialogFormVisible = true;
                this.optflag = 'save'
            },
            handleEdit(obj){
                //设置提交的字段
                this.f = {
                    ...obj,
                    cityArray: []
                };
                // 2. 先清空一下旧的城市列表，防止闪烁
                this.salesCityList = [];
                this.dialogFormVisible = true;
                this.optflag = 'update'
                //调用查询城市的方法
                this.changeArea(this.f.province).then(() => {
                    this.$nextTick(() => {
                        if (obj.city) {
                            this.f.cityArray = obj.city.split('、').map(item => item.trim());
                            console.log("this.f.cityArray",this.f.cityArray)
                        }
                    });
                });
            },
            handleDelete(obj){
                this.$msg.confirm("确认删除?",()=>{
                    ss.clueOwner.designDeleteById({id:obj.id}).then(rd=>{
                        this.$msg.msgs("删除成功！");
                        this.query();
                    });
                })
            },
            //保存数据字典
            saveOrUpdate(){
                //将数组转为字符串
                if(this.f.cityArray){
                    this.f.city = this.f.cityArray.join('、')
                    this.f.cityArray = null;
                }

                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        var retobj = null;
                        if(this.optflag == 'save'){
                            retobj = ss.clueOwner.designInsert(this.f);
                        }else if(this.optflag =="update"){
                            retobj = ss.clueOwner.designUpdateById(this.f);
                        }
                        retobj.then(rd=>{
                            this.dialogFormVisible = false;
                            this.$msg.msgs("操作成功！");

                            this.query();
                        });
                    } else {
                        return false;
                    }
                });
            },
            //关闭
            closeM(){

                this.dialogFormVisible = false;

            },
            cleanQUdao(){
              this.f.channelCode='' ;
              this.f.channelName='' ;
            },

            //选中
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //明细导出
            exportExcel() {
                var idlist = [];
                this.multipleSelection.forEach(element => {
                    idlist.push(element.id);
                });
                updownfile.down("/api/swyl/v1/demo/bscDesignClueOwner/downloadExcel", idlist, "get", 'data');
            },
            //导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback(rd) {
                this.query();
                this.$msg.msgs(rd.msg);
            },
        }
    }
</script>
